
import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "./ui/table";

type Security = {
  allotment_date: string;
  allotment_type: string;
  instrument: string;
  total_amount_raised: number;
  number_of_securities_allotted: number;
  nominal_amount_per_security: number;
  premium_amount_per_security: number;
};

type SecuritiesAllotmentProps = {
  securities?: Security[] | null;
};

// Format date function
const formatDate = (dateString: string) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

// Format currency
const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(amount);
};

const SecuritiesAllotment: React.FC<SecuritiesAllotmentProps> = ({
  securities,
}) => {
  if (!securities || securities.length === 0) {
    return (
      <div className="text-gray-500 text-center py-8">
        This company has no recorded securities allotment data.
      </div>
    );
  }

  return (
    <div className="w-full rounded-lg border overflow-hidden">
       <h2 className="text-xl font-bold mb-4">Securities Allotment</h2>
      <Table>
        <TableHeader>
          <TableRow className="bg-gray-50">
            <TableHead className="font-semibold" >Allotment Date</TableHead>
            <TableHead className="font-semibold" >Allotment Type</TableHead>
            <TableHead className="font-semibold" >Instrument</TableHead>
            <TableHead className="font-semibold" >Amount</TableHead>
            <TableHead className="font-semibold" >No. of Securities Allotted</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {securities.map((security, index) => (
            <TableRow key={index} className="hover:bg-gray-50 bg-white transition-colors">
              <TableCell>{formatDate(security.allotment_date)}</TableCell>
              <TableCell>{security.allotment_type}</TableCell>
              <TableCell>{security.instrument}</TableCell>
              <TableCell>
                {formatCurrency(security.total_amount_raised)}
              </TableCell>
              <TableCell>
                {new Intl.NumberFormat("en-IN").format(
                  security.number_of_securities_allotted
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default SecuritiesAllotment;
